module.exports = __webpack_public_path__ + "static/vista-explodida-3-8d31605946ae0787a0ace84b12f62d5a.png";